import React, { useEffect, useState } from 'react';
import Guarantee from './guarantee';
import ReportMisconduct from './report-misconduct';
import { useLanguage } from '../../helpers/language-context';
import { renderHTML } from '../../helpers/render-html';
import { supabase } from '../../supabaseClient';
import ImageModal from '../../components/common/ImageModal';

const ArrowRight = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"></line>
    <polyline points="12 5 19 12 12 19"></polyline>
  </svg>
);

const Policies = () => {
  const { translations, language } = useLanguage();
  const [whistleblower, setWhistleblower] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const fetchWhistleblower = async () => {
      const { data, error } = await supabase
        .from('whistleblower')
        .select('*')
        .order('id', { ascending: true });
      if (!error) setWhistleblower(data);
    };
    fetchWhistleblower();
  }, []);

  const getLocalized = (item, keyBase) => {
    if (language === 'ms') return item[`${keyBase}-ms`] ?? item[`${keyBase}-en`];
    return item[`${keyBase}-en`];
  };

  return (
    <div>
      <section>
        <ImageModal
          isOpen={!!selectedImage}
          onClose={() => setSelectedImage(null)}
          imageUrl={selectedImage}
        />
        <div className="flex flex-col space-y-8 justify-center items-start mx-auto mb-10">
          <div>
            <h2 className="text-[#28357B] text-4xl md:text-5xl lg:text-6xl" dangerouslySetInnerHTML={renderHTML(translations.governance.whistleblowing)} />
          </div>
          <div className="space-y-2 md:max-w-[80%]">
            <p className="text-md mb-4" dangerouslySetInnerHTML={renderHTML(translations.governance.whistleblowingDesc)} />
          </div>
        </div>

        <div className="flex border-b border-[#E0E0E0] text-[#999999] font-medium">
          <div className="w-1/5">
            <p className="text-md mb-4" dangerouslySetInnerHTML={renderHTML(translations.governance.policy)} />
          </div>
          <div className="hidden md:block w-4/5 pl-4">
            <p className="text-md mb-4" dangerouslySetInnerHTML={renderHTML(translations.governance.description)} />
          </div>
        </div>

        {/* policies list */}
        {whistleblower.map((whistleblower) => (
          <div key={whistleblower.id} className="flex items-center md:items-start border-b border-[#E0E0E0] font-medium py-12">
            <div className="w-4/5 md:w-1/5 md:pr-0 pr-4">
              <p className="text-md mb-4 md:mb-0" dangerouslySetInnerHTML={renderHTML(getLocalized(whistleblower, 'whistleblowing'))} />
              <p className="text-md text-[#666666] md:hidden text-justify" dangerouslySetInnerHTML={renderHTML(getLocalized(whistleblower, 'description'))} />
            </div>

            <div className="hidden md:block mt-4 md:mt-0 md:w-3/5 text-[#666666] pl-4">
              <p className="text-md" dangerouslySetInnerHTML={renderHTML(getLocalized(whistleblower, 'description'))} />
            </div>

            <div className="w-1/5 text-[#666666] pl-4">
              <button
                onClick={() => setSelectedImage(whistleblower.url)}
                className="flex items-center justify-end gap-2 text-sm text-[#28357B] hover:underline focus:outline-none"
              >
                <span>{translations.button.read}</span>
                <ArrowRight />
              </button>
            </div>
          </div>
        ))}
      </section>

      <Guarantee />
      <ReportMisconduct />
    </div>
  );
};

export default Policies;
